import React from 'react';

const InformationTab = ({ dataSource }) => {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="db-list-item p-0">
                <span className="db-list-item-title w-full sm:w-1/2">name</span>
                <span className="db-list-item-text w-full sm:w-1/2">{dataSource?.name}</span>
            </div>

            <div className="db-list-item p-0">
                <span className="db-list-item-title w-full sm:w-1/2">price</span>
                <span className="db-list-item-text w-full sm:w-1/2">{dataSource?.price}</span>
            </div>

            <div className="db-list-item p-0">
                <span className="db-list-item-title w-full sm:w-1/2">category</span>
                <span className="db-list-item-text w-full sm:w-1/2">{dataSource?.item_category_id?.name}</span>
            </div>

            <div className="db-list-item p-0">
                <span className="db-list-item-title w-full sm:w-1/2">tax</span>
                <span className="db-list-item-text w-full sm:w-1/2">{dataSource?.tax_id?.name}</span>
            </div>

            <div className="db-list-item p-0">
                <span className="db-list-item-title w-full sm:w-1/2">type</span>
                <span className="db-list-item-text w-full sm:w-1/2">
                    {dataSource.item_type && dataSource.item_type == '1' ? <span className={'active'}>Veg</span> : <span className={'inactive'}>Non Veg</span>}
                </span>
            </div>

            <div className="db-list-item p-0">
                <span className="db-list-item-title w-full sm:w-1/2">featured</span>
                <span className="db-list-item-text w-full sm:w-1/2">
                    {dataSource.is_featured && dataSource.is_featured == '1' ? <span className={'active'}>No</span> : <span className={'inactive'}>Yes</span>}
                </span>
            </div>

            <div className="db-list-item p-0">
                <span className="db-list-item-title w-full sm:w-1/2">status</span>
                <span className="db-list-item-text w-full sm:w-1/2">
                    {dataSource.status && dataSource.status == '1' ? <span className={'active'}>Active</span> : <span className={'inactive'}>Inactive</span>}
                </span>
            </div>

            <div className="db-list-item p-0">
                <span className="db-list-item-text mt-2 w-full">
                    <span className="mt-2 db-list-item-title">caution</span> <br />
                    <span className="mt-2">{dataSource?.caution}</span>
                </span>
            </div>
            <div className="db-list-item p-0">
                <span className="db-list-item-text mt-2 w-full">
                    <span className="mt-2 db-list-item-title">description</span>
                    <br />
                    <span className="mt-2">{dataSource?.description}</span>
                </span>
            </div>
        </div>
    );
};

export default InformationTab;
